import React, { useState } from "react";

const Search = (props) => {
	const [value, setValue] = useState(props.searchValue);

	const handleChange = (e) => {
		setValue(e.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (value !== props.searchValue) {
			props.setSearchValue(value);
		}
	};

	/*     const inputRef = useRef()
    
     useEffect(() => {
        inputRef.current.focus()
    }, [])

     const handleChange = (e) => {
        props.setSearchValue(e.currentTarget.value)
    } */

	return (
		<form
			className="kt-subheader__search"
			id="kt_subheader_search_form"
			onSubmit={handleSubmit}
		>
			<div
				className="input-group"
				style={{ display: "flex", alignItems: "center" }}
			>
				<label htmlFor="generalSearch" className="m-2">
					Search:
				</label>
				<input
					type="text"
					className="form-control"
					id="generalSearch"
					value={value}
					onChange={handleChange}
					/*           ref={inputRef}
					 */
					style={{ width: "50%" }}
				/>
				{/* <div className='input-group-append'>
          <span className='input-group-text' id='basic-addon2'>
            <i className='flaticon2-search-1'></i>
          </span>
        </div> */}
			</div>
		</form>
	);
};

export default Search;
